import React, { forwardRef, useId } from 'react';

interface ProcSectionProps {
  /** The section heading (the standard `form-section-title`). */
  title: string;
  /** Accessible name when it should differ from the visible heading. */
  ariaLabel?: string;
  /** A control that sits on the heading row (Add line, a status badge...). */
  action?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * One group on a Procurement detail page. It is the standard form page's
 * `form-section` with its `form-section-title`, so fields, sub-tables and
 * panels (lines, parcels, receiving, landed cost, rates) all sit in the same
 * ruled sections as the Stationery item page instead of in their own bordered
 * cards. The heading row can carry one action.
 */
const ProcSection = forwardRef<HTMLElement, ProcSectionProps>(({ title, ariaLabel, action, children }, ref) => {
  const headingId = useId();
  return (
    <section ref={ref} className="form-section" {...(ariaLabel ? { 'aria-label': ariaLabel } : { 'aria-labelledby': headingId })}>
      <div className="proc-section-head">
        <h3 className="form-section-title" id={headingId}>{title}</h3>
        {action}
      </div>
      {children}
    </section>
  );
});
ProcSection.displayName = 'ProcSection';

export default ProcSection;
